import { useAppKit } from '@reown/appkit/react';
import { useAppKitAccount, useDisconnect } from '@reown/appkit/react';

export const useConnectSolanaWallet = () => {
  const { open } = useAppKit();
  const appKitAccount = useAppKitAccount({ namespace: 'solana' });
  const { disconnect } = useDisconnect();

  return {
    address: appKitAccount.address ?? null,
    isConnected: appKitAccount.isConnected,
    connect: () => {
      return void open({ view: 'Connect', namespace: 'solana' });
    },
    disconnect,
  };
};
